import { useState } from "react";
import { Textareawithsteroids, Textareawithsteroids2 } from "../ESG/EnvironmentReport";
import { HeaderShow } from "../ESG/ESGmain";

const Step2 = () => {
    const [showContent,setShowContent] = useState(false)
    const subtext = `Either use an existing, or create a value chain overview as you best can, in our tool to do so in the ambition tap, Write down everything you know all through the value chain from raw material, through refinement, to suppliers, transportation, direct company activities to use and end of life, towards new use of the resources.\


Action: Read the next section, then read the subgoals and note down which you can conceretely influence`
    const actiontext = `Make a draft overview of your value chain, ask colleagues and suppliers for input`
    const exercisetext = `Go sit together with someone in another department at lunch and pick their brain for knowledge on their part of the value chain`

    return ( 
        <div className="d-flex flex-column align-items-center mt-2">
        <HeaderShow text={"Step 2 Research"} show={showContent} setShow={()=>setShowContent(!showContent)}/>
        
        {
            showContent ?
            <>
            <div className="roleambition__bubble w-90 mt-3 ms-0">
                <h5>{subtext}</h5>
                <div className="d-flex justify-content-between mt-2">
                    <div className="d-flex flex-column me-5">
                        <h5 style={{textAlign:"center"}}><b>Action</b></h5>
                        <h5>{actiontext}</h5>
                    </div>
                    <div className="d-flex flex-column">
                        <h5 style={{textAlign:"center"}}><b>Exercise</b></h5>
                        <h5>{exercisetext}</h5>
                    </div>
                </div>
            </div>
            <div className="d-flex align-items-center justify-content-around w-90">
                <div className="sdg__action__exercise">
                    <h4>Action:</h4><Textareawithsteroids2   
                        maxLength={3000}
                        keyHighlight={"step2_action"}
                    />        
                </div>
                <div className="sdg__action__exercise">
                    <h4>Exercise:</h4><Textareawithsteroids2   
                        maxLength={3000}
                        keyHighlight={"step2_exercise"}
                    />        
                </div>
            </div>
            <div className="sdg__action__exercise w-85">
                <h4>Write in your conclusions here:</h4><Textareawithsteroids2   
                    maxLength={3000}
                    keyHighlight={"step2_conclusion"}
                />        
            </div>
            </>:null
        }
        
        </div>
        );
}
 
export default Step2;